import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon2: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='108'
      height='78'
      viewBox='0 0 108 78'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='18.9004' y='19.2407' width='79.6' height='53.6' fill='#BEEBFF' stroke='#404040' />
      <circle cx='18.4004' cy='18.7412' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M18.07 22.5852H23.092V24.2412H14.578V23.8092L18.808 19.2552C20.122 17.8692 20.698 17.0052 20.698 15.9972C20.698 14.7912 19.924 13.9092 18.718 13.9092C17.512 13.9092 16.702 14.8452 16.702 16.0692C16.702 16.3212 16.738 16.6272 16.792 16.9872H14.866C14.776 16.6632 14.74 16.3212 14.74 15.9612C14.74 14.0172 16.306 12.1632 18.736 12.1632C21.004 12.1632 22.678 13.7652 22.678 15.8532C22.678 16.6632 22.462 17.4012 22.03 18.0672C21.616 18.7332 20.986 19.4892 20.158 20.3712L18.07 22.5852Z'
        fill='#404040'
      />
      <path d='M52.6807 54.5576L65.317 41.5264' stroke='#404040' strokeMiterlimit='10' />
      <path
        d='M64.1324 54.5572C65.659 54.5572 66.8966 53.3196 66.8966 51.793C66.8966 50.2664 65.659 49.0288 64.1324 49.0288C62.6057 49.0288 61.3682 50.2664 61.3682 51.793C61.3682 53.3196 62.6057 54.5572 64.1324 54.5572Z'
        stroke='#404040'
        strokeMiterlimit='10'
      />
      <path
        d='M53.8658 47.0548C55.3924 47.0548 56.63 45.8172 56.63 44.2906C56.63 42.7639 55.3924 41.5264 53.8658 41.5264C52.3391 41.5264 51.1016 42.7639 51.1016 44.2906C51.1016 45.8172 52.3391 47.0548 53.8658 47.0548Z'
        stroke='#404040'
        strokeMiterlimit='10'
      />
      <circle cx='59' cy='48.0415' r='14.0918' stroke='#404040' />
      <rect x='15' y='72.541' width='87.4' height='4.2' fill='#BEEBFF' stroke='#404040' />
      <path d='M92.5002 25.2407L78.2002 37.5907' stroke='#404040' />
      <path d='M92.5002 31.7407L84.7002 38.2407' stroke='#404040' />
      <path d='M86.0002 23.9409L78.2002 30.4409' stroke='#404040' />
    </svg>
  );
};

export default memo(InfoBlockIcon2);
